export default class GetPerfilCursoById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPerfilCurso) {
    try {
      const result = await this.#repository.getPerfilCursoById(idPerfilCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
